import communesJson from './communes-npdc-10k-plus.json'
import type { CommuneNpdc } from '../types/Commune'
import {
  buildCommuneUrls,
  LOCAL_HUB_SERVICE_ID,
  LOCAL_SERVICES,
  LOCAL_ZONES_INDEX_PATH,
  localCityHubPath,
  serviceCityPath,
  getLocalServiceById
} from '../config/localServices'
import { shouldIndexCommune as checkIndexable } from '../config/localSeoPolicy'

const rawCommunes = communesJson as CommuneNpdc[]

function enrichCommune(c: CommuneNpdc): CommuneNpdc {
  const urls = buildCommuneUrls(c.slug)
  return {
    ...c,
    urls,
    url_agence_web: urls['agence-web'],
    url_creation_site: urls['creation-site-vitrine']
  }
}

/** Siège PostDev — page locale même si < 10 000 hab. */
export const LILLERS: CommuneNpdc = enrichCommune({
  nom: 'Lillers',
  slug: 'lillers',
  dep_code: '62',
  dep_nom: 'Pas-de-Calais',
  population: 9500,
  code_postal: '62190',
  code_insee: '62475',
  epci: 'Communauté d\'agglomération de Béthune-Bruay, Artois-Lys Romane',
  priorite: 'P1',
  latitude: 50.563,
  longitude: 2.483
})

const bySlug = new Map<string, CommuneNpdc>()

function register(c: CommuneNpdc): void {
  bySlug.set(c.slug, c)
}

for (const c of rawCommunes) {
  register(enrichCommune(c))
}
register(LILLERS)

export function getAllCommunes(): CommuneNpdc[] {
  return [...rawCommunes.map(enrichCommune), LILLERS].sort(
    (a, b) => b.population - a.population || a.nom.localeCompare(b.nom, 'fr')
  )
}

export function getCommuneBySlug(slug: string): CommuneNpdc | undefined {
  return bySlug.get(slug.toLowerCase().replace(/\/+$/, ''))
}

export function getCommunesByPriority(priorite: CommuneNpdc['priorite']): CommuneNpdc[] {
  return getAllCommunes().filter((c) => c.priorite === priorite)
}

export function getFooterCommunes(): CommuneNpdc[] {
  return getCommunesByPriority('P0')
}

export function localPath(slug: string): string {
  return localCityHubPath(slug)
}

export function localServicePath(serviceId: string, citySlug: string): string {
  const svc = getLocalServiceById(serviceId)
  if (!svc) return localPath(citySlug)
  return serviceCityPath(svc, citySlug)
}

export { LOCAL_HUB_SERVICE_ID, LOCAL_ZONES_INDEX_PATH, localCityHubPath }

export function shouldIndexCommune(commune: CommuneNpdc | undefined): boolean {
  return checkIndexable(commune)
}

/** Toutes les communes (indexation immédiate). */
export function getIndexableCommunes(): CommuneNpdc[] {
  return getAllCommunes().filter((c) => checkIndexable(c))
}

export function countLocalPagesForSitemap(): { communes: number; urls: number; services: number } {
  const communes = getIndexableCommunes().length
  const services = LOCAL_SERVICES.length
  return {
    communes,
    services,
    urls: 1 + communes * (1 + services)
  }
}
